import { render, staticRenderFns } from "./AccessInformation.vue?vue&type=template&id=069d168a&scoped=true"
import script from "./AccessInformation.vue?vue&type=script&lang=ts"
export * from "./AccessInformation.vue?vue&type=script&lang=ts"
import style0 from "./AccessInformation.vue?vue&type=style&index=0&id=069d168a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d168a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069d168a')) {
      api.createRecord('069d168a', component.options)
    } else {
      api.reload('069d168a', component.options)
    }
    module.hot.accept("./AccessInformation.vue?vue&type=template&id=069d168a&scoped=true", function () {
      api.rerender('069d168a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/AccessInformation.vue"
export default component.exports